import { createContext } from "react";
import { defaultBranding } from "./default.ts";

export interface Branding {
    cssVariables: Record<string, string>;
    envVariables: Record<string, string>;
}

export const BrandingContext = createContext<Branding>(defaultBranding());
